import RangeOfDaysPayout from './RangeOfDaysPayout'

export default RangeOfDaysPayout
